'use client';

import { useState, useEffect } from "react";
import CustomTable from "../../components/CustomTable";
import ModalVeiculo from "./ModalVeiculo";
import ModalRetorno from "../../components/ModalRetorno";

export interface TableProps {
  headers: any[];
  dados: any[];
  valoPesquisa?: string;
  onDelete?: (selectedData: any[]) => void;
}

export default function TabelaVeiculo({ headers, onDelete, dados, valoPesquisa }: TableProps) {
  const [tableData, setTableData] = useState(dados);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Estados para o ModalRetorno (feedback)
  const [modalRetornoOpen, setModalRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState("");
  const [tipoRetorno, setTipoRetorno] = useState<"sucesso" | "erro">("sucesso");

  // Atualiza os dados da tabela quando a prop "dados" muda
  useEffect(() => {
    setTableData(dados);
  }, [dados]);

  // Função para deletar os registros selecionados
  const handleDeleteRecords = (selectedData: any[]) => {
    const selectedIds = selectedData.map(item => item.id);
    const newData = tableData.filter(item => !selectedIds.includes(item.id));
    setTableData(newData);
    if (onDelete) {
      onDelete(selectedData);
    }
    setMensagemRetorno("Veículo(s) excluído(s) com sucesso!");
    setTipoRetorno("sucesso");
    setModalRetornoOpen(true);
  };

  // Função para adicionar um novo veículo
  const handleAddVeiculo = (novoVeiculo: any) => {
    if (novoVeiculo && novoVeiculo.name && novoVeiculo.name.trim() !== "") {
      setTableData(prevData => [
        ...prevData,
        { id: prevData.length + 1, ...novoVeiculo, ativo: true },
      ]);
      setIsModalOpen(false);
      setMensagemRetorno("Veículo adicionado com sucesso!");
      setTipoRetorno("sucesso");
      setModalRetornoOpen(true);
    }
  };

  const handleDataChange = (newData: any[]) => {
    setTableData(newData);
  };

  return (
    <>
      <CustomTable
        headers={headers}
        data={tableData}
        searchValue={valoPesquisa}
        onDelete={handleDeleteRecords}
        onAdd={() => setIsModalOpen(true)}
        onDataChange={handleDataChange}
        addButtonLabel="Adicionar"
        deleteButtonLabel="Excluir"
        showActions={true}
      />

      <ModalVeiculo
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        handleAddVeiculo={handleAddVeiculo}
      />

      <ModalRetorno
        isOpen={modalRetornoOpen}
        onClose={() => setModalRetornoOpen(false)}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}
